import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, NavigationEnd, NavigationError, Params, Router, RouterEvent} from "@angular/router";
import {combineLatest, Subject} from "rxjs";
import {first, map, takeUntil} from "rxjs/operators";
import {AppService, VehicleService} from "./clearpath-module/services";
import {AuthService} from "./auth-module/services";
import {User} from "./user-admin-module/models";
import {PubnubService} from "./shared-module/services";
import {USER_ROLES} from "./app.config";
import {Vehicle} from "./clearpath-module/models";
import * as rg4js from "raygun4js";
import {AuthService as Auth0Service} from '@auth0/auth0-angular';
import {MatSidenavContent} from "@angular/material/sidenav";
import {MatDialog} from "@angular/material/dialog";
import {
  ImportInventoryDialogComponent
} from "./shared-module/components/dialogs/import-inventory-dialog/import-inventory-dialog.component";

export function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('mainSidenavContent') mainSidenavContent: MatSidenavContent;
  @ViewChild('sidenavContent') sidenavContent: MatSidenavContent;

  private unsubscribe$: Subject<any> = new Subject();

  // private timerSubscription: Subscription;
  // private readonly CHECK_INTERVAL = 60000; // 1 minute in milliseconds

  currentRelease: string = "3.1.6338"; // ONLY UPDATE MAJOR.MINOR FOR RELEASES, the 111 is auto-updated via CI/CD pipeline
  public currentUser: User;
  currentRoute: string;

  initialDataLoaded: boolean = false;

  constructor(
    public appService: AppService,
    private authService: AuthService,
    private router: Router,
    private vehicleService: VehicleService,
    private pubsub: PubnubService,
    private activatedRoute: ActivatedRoute,
    private auth0: Auth0Service,
    private dialog: MatDialog,
  ) {
  }

  private checkAndRedirectToFly(): void {
    const currentHost = window.location.hostname;

    // Check if we're on Auth0 callback (has code or state params)
    const urlParams = new URLSearchParams(window.location.search);
    const isAuth0Callback = urlParams.has('code') || urlParams.has('state');

    // Skip redirect if we're in an Auth0 callback flow
    if (isAuth0Callback) {
      console.log('Auth0 callback detected, skipping redirect');
      return;
    }

    // Define redirect mappings
    const redirectMap = {
      'northstar-stage.herokuapp.com': 'northstar-stage.fly.dev',
      'northstar-prod.herokuapp.com': 'northstar-prod.fly.dev',
      'northstar-auto.com': 'northstar-prod.fly.dev',
      'www.northstar-auto.com': 'northstar-prod.fly.dev',
      'stage.northstar-auto.com': 'northstar-stage.fly.dev'
    };

    // Check if current host needs redirect
    if (redirectMap[currentHost]) {
      const newHost = redirectMap[currentHost];
      const newUrl = `${window.location.protocol}//${newHost}${window.location.pathname}${window.location.search}${window.location.hash}`;

      console.log(`Redirecting from ${currentHost} to ${newHost}`);
      window.location.replace(newUrl);
    }
  }

  ngOnInit() {
    // Check and redirect to Fly instances if on Heroku (initial check)
    this.checkAndRedirectToFly();

    //this.redirectToHttps();
    console.log('---------------------------------------------------');
    console.log("Starting: Northstar_Release_" + this.currentRelease);

    this.appService.originalUrl = window.location.pathname;
    this.appService.currentRelease = this.currentRelease;

    //this.startTokenTimer();

    this.auth0.appState$.subscribe(appState => {
      if (appState.returnTo && appState.returnTo.length > 1) {
        this.appService.returnTo = appState.returnTo.replace("(modal:submit-writeup)", "");
      }
    });

    combineLatest([this.auth0.isAuthenticated$]).pipe(
      map(([isAuthenticated]) => {
        if (!isAuthenticated) {
          console.log("User not authenticated in root (Auth0 login).");
          this.auth0.loginWithRedirect({
            appState: {
              returnTo: this.appService.originalUrl
            }
          });
        } else {
          console.log("User is authenticated in root.");
          // Check again after authentication in case Auth0 redirected to Heroku
          this.checkAndRedirectToFly();

          combineLatest([this.auth0.getAccessTokenSilently()])
            .pipe(first())
            .subscribe(([token]) => {
              console.log("token", token);
              if (!this.authService.token) {
                console.log("User authenticated in root but no user token--fetching token.");
                this.authService.loginWithToken(token);
              } else {
                let navigateUrl = this.appService.originalUrl != "/" ? this.appService.originalUrl : "clearpath/list";
                console.log("Token valid , navigating to original URL.", navigateUrl, this.appService.originalUrl);
                this.router.navigate([navigateUrl], { queryParamsHandling: 'preserve' }).then();
              }
            });
        }
      })).subscribe();

    this.setToken();
    this.subToCurrentUserAndVehicles();
    this.subToRouterEvents();
    this.pubsub.watchMsgChannel();
  }

  /*  private startTokenTimer() {
      this.timerSubscription = interval(this.CHECK_INTERVAL)
        .pipe(
          tap(() => {
            this.auth0.isAuthenticated$.subscribe(isAuthenticated => {
              if (!isAuthenticated) {
                // console.log('Token expired, initiating logout...');
                //this.authService.logout();
              } else {
                // console.log('Token still valid.');
              }
            });
          })
        )
        .subscribe();


      this.timerSubscription = interval(this.CHECK_INTERVAL)
        .pipe(
          tap(() => {
            this.auth0.getAccessTokenSilently().subscribe(token => {
              //console.log(token);
              if (!token) return 0;
              try {
                const tokenPayload = JSON.parse(atob(token.split('.')[ 1 ]));
                // console.log(tokenPayload);
                const expirationTime = tokenPayload.exp * 1000; // Convert to milliseconds
                const timeRemaining = Math.max(0, expirationTime - Date.now());
                // console.log(`Token expires in: ${this.formatTimeRemaining(timeRemaining)}`);
              } catch (e) {
                // console.error('Error parsing token:', e);
                return 0;
              }
            });
          })
        )
        .subscribe();
    }*/

  /*formatTimeRemaining(ms: number): string {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}m ${seconds}s`;
  }*/

  /**
   * Redirect to HTTPS if currently on HTTP
   */

  /*  private redirectToHttps(): void {
      if (
        this.document.location.protocol === 'http:' &&
        !this.document.location.hostname.includes('localhost')
      ) {
        const httpsUrl = new URL(this.document.location.href);
        httpsUrl.protocol = 'https:';

        // Preserve path and query parameters
        httpsUrl.pathname = this.document.location.pathname;
        httpsUrl.search = this.document.location.search;
        httpsUrl.hash = this.document.location.hash;

        // Perform the redirect
        this.document.location.href = httpsUrl.toString();
      }
    }*/

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  // login with param token or try to reuse token on refresh
  setToken() {
    // subscribe to router event and extract token from params if exists
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.token) {
        this.authService.loginWithToken(params.token);
      } else {
        this.authService.reuseToken();
      }
    });
  }

  subToCurrentUserAndVehicles() {
    combineLatest([
      this.authService.selectUser(),
      this.vehicleService.selectVehicles()
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([user, vehicles]: [User, Vehicle[]]) => {
        this.currentUser = user;
        // console.log("Current User: ", this.currentUser);
        if ((!vehicles || !vehicles.length) && user) {
          this.vehicleService.dispatchGetAllVehicles();
        }

        if (user && !this.initialDataLoaded) {
          this.initialDataLoaded = true;
          this.appService.getAppSettingsData();
        }
      });
  }

  get isSalesManager(): boolean {
    if (this.currentUser) {
      const userRoles = User.unpackSecurityGroups(this.currentUser.securityGroups);
      if (userRoles.includes(USER_ROLES.sales_manager)) {
        return true;
      }
    }
    return false;
  }

  get isSysAdmin(): boolean {
    if (this.currentUser) {
      const userRoles = User.unpackSecurityGroups(this.currentUser.securityGroups);
      if (userRoles.includes(USER_ROLES.sys_admin)) {
        return true;
      }
    }
    return false;
  }

  subToRouterEvents() {
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event: RouterEvent) => {
        const navigationEnd = event instanceof NavigationEnd;
        const includesUrl = event.url !== undefined;
        if (navigationEnd && includesUrl) {
          this.currentRoute = event.url;

          // Check on each navigation in case URL changed
          this.checkAndRedirectToFly();

          // Scroll to top on every navigation except opening a modal, so the page stays put behind it
          const openingModal = !!this.router.parseUrl(event.url).root.children.modal;
          if (this.sidenavContent && !openingModal) {
            this.sidenavContent.scrollTo({top: 0, behavior: 'auto'});
          }
        }

        if (event instanceof NavigationEnd) {
          rg4js("trackEvent", {
            type: "pageView",
            path: event.url
          });
        }

        // Track navigation errors when the NavigationError event occurs
        if (event instanceof NavigationError) {
          // Track navigation error
          rg4js("send", {
            error: event.error
          });
        }
      });
  }

  logout() {
    this.authService.logout();
  }

  closeUserSidenav() {
    console.log("closeUserSidenav");
    this.appService.userSidenavOpened = false;
  }

  toggleDev() {
    console.log("openDev");
    this.appService.devSidenavOpened = !this.appService.devSidenavOpened;
    this.closeUserSidenav()
  }

  modulePathLink(path: string) {
    console.log("modulePresentation");
    this.router.navigate([path]).then();
    this.closeUserSidenav();
  }

  onActivate(event) {
    //this.myScrollContainer.scrollable.getElementRef().nativeElement.scrollTop= 0;
  }

  openGetInventoryDialog() {
    const dialogRef = this.dialog.open(ImportInventoryDialogComponent, {
      width: '500px',
      autoFocus: false,
    });
  }

  showDashboard() {
    this.router.navigate(["dashboard"]).then();
    this.closeUserSidenav();
  }
}
